<div *ngIf="currentFrac$ | async as currentFrac">
  <div class="text-lg mt-2 mb-2">
    {{ currentFrac.autoPurchaseOrderAssignment ? 'Disengage' : 'Engage' }} Auto-Allocation
  </div>
  <div class="text-sm mt-2 mb-2">
    Auto-Allocation allows SANDi to make intelligent decisions for you by auto-assigning relevant Purchase Orders to
    your well.
  </div>

  <div class="flex justify-between">
    <button
      *ngIf="currentFrac.autoPurchaseOrderAssignment"
      mat-raised-button
      color="warn"
      (click)="updateStatus(false)"
    >
      Disengage
    </button>
    <button
      *ngIf="!currentFrac.autoPurchaseOrderAssignment"
      mat-raised-button
      color="primary"
      (click)="updateStatus(true)"
    >
      Engage
    </button>
    <button mat-raised-button (click)="cancelAction()">
      Cancel
    </button>
  </div>
</div>
